import React, { Component } from "react";
import { USERURL } from '../../constant';


import {Helmet} from "react-helmet";

import logoBewise from '../../assets/images/bewise-logo-new.png';

class HeaderNew extends Component {
  constructor(props) {
    super(props);
    let path = window.location.pathname;
    this.state = {
      authe: false,
      logged_user_name: "",
      login_path: path == '/' ? '/admin_login' : '/login',
      signup_path: path == 'individual' ? '/individual_signup' : '/institution_signup',
    };
  }
  componentDidMount() {
    console.log('window.location.pathname', window.location.pathname);
    let logged = localStorage.getItem("authentication");
    let auth_data = JSON.parse(localStorage.getItem("user_data"));
    console.log("auth_data", typeof logged);
    if (auth_data) {
      this.setState({
        authe: logged == "true" ? true : false,
        logged_user_name: auth_data.user_name,
      });
    }
  }
  logoutSess(e) {
    localStorage.clear();
    setTimeout(function () {
      window.location = "/";
    }, 1000);
  }
  render() {
    return (


          <div style={{
              position: "fixed",
              zIndex: "999",
              background: "#fff",
              width: "100%",
              top: 0
          }} class="container-fluid">

          <div className='tranparent-header-custom-inner'>
            <div className='container-fluid'>
              <div className='row display-flex-center header-custom stickymenu sticky-top desktop'>
                <div className='col-lg-3 col-md-3 col-sm-3 bewise-logo-block'>
                  <div className='bewise-logo active'>
                    <div class="row  display-flex-center">
                      <div>
                        <a className='logo-text' href='/'>
                          <img src={logoBewise} className="mainlogoimg" style={{ width: "50px", marginRight: "2px" }} />
                        </a>
                      </div>
                      <div className="mainlogotext">
                        <h5 style={{ lineHeight: "3px", marginTop: "10px", fontWeight: "bold"  }}>BeWise</h5>
                        <p className="logoslogan" style={{ fontSize: "8px", fontWeight: "bold" }}>Enabling Learning & Fun</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='col-lg-6 col-md-6 col-sm-6' style={{ textAlign: "center" }}>
                  <div className="topheading mainsearchareatop s003" style={{ display: "none" }}>
                      <div class="bheader">Welcome to <span className="bluetext">BeWise</span> Partner Program</div>
                  </div>
                </div>
                <div className='col-lg-3 col-md-3 col-sm-3 text-right bewise-signin-block'>
                     <a href="/login" className="nsignbtn">Sign In</a>
                </div>
              </div>

              <div className='row mobile'>

                <div className='col-xs-8 bewise-logo-block' style={{ paddingLeft: "0px"}}>
                  <div className='bewise-logo active'>
                    <div class="leftLogo"><a className='logo-text' href='/'>
                          <img src={logoBewise} className="mainlogoimg" style={{ width: "55px", marginRight: "2px" }} />
                        </a>
                    </div>
                    <div className="rightLogo">
                        <h5 style={{ lineHeight: "3px", marginTop: "10px", fontWeight: "bold" }}>BeWise</h5>
                        <p className="logoslogan" style={{ fontSize: "8px", fontWeight: "bold"}}>Enabling Learning & Fun</p>
                    </div>
                    { /* <div class="row">
                      <div className='col-xs-3'>
                        <a className='logo-text' href='/'>
                          <img src={logoBewise} className="mainlogoimg" style={{ width: "55px", marginRight: "2px" }} />
                        </a>
                      </div>
                      <div className="col-xs-9 mainlogotext">
                        <h5 style={{ lineHeight: "3px", marginTop: "10px", fontWeight: "bold" }}>BeWise</h5>
                        <p className="logoslogan" style={{ fontSize: "8px", fontWeight: "bold"}}>Enabling Learning & Fun</p>
                      </div>
                    </div> */ }

                  </div>
                </div>
                
                <div className='col-xs-4 text-right bewise-signin-block'>
                     <a href="/login" className="nsignbtn">Sign In</a>
                </div>

              </div>
              <div className='row align-items-center mobile'>
                <div className='col-sm-12' style={{ textAlign: "center" }}>
                    <div class="bheader">Welcome to <span className="bluetext">BeWise</span> Partner Program</div>
                </div>

              </div>

            </div>
          </div>
                    
        </div>

    );
  }
}

export default HeaderNew;



// WEBPACK FOOTER //
// ./src/components/LandingPages/HeaderNew.jsx